module.exports = __webpack_public_path__ + "img/h1.b283fac9.png";